// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___1GXSd","UCONN":"styles__UCONN___2tVh1","universityOfConnecticut":"styles__universityOfConnecticut___2UcP-"};